export default "__VITE_ASSET__GCB_Qyb5__"